import React, { useCallback, useMemo, useState } from 'react'

import { Container, Modal, ModalBody, ModalFooter, ModalHeader, Row, Col, FormGroup, Label, Input, Button, CustomInput } from "reactstrap"
import Cargando from '../../Varios/Cargando';
import IconCloseModal from '../../Varios/Modals/IconCloseModal';

export type PropsModalConfirmacion = {
    show: boolean,
    size: "xl" | "sm" | "md" | "lg",
    asyncAccion: boolean,
    asyncClose: boolean,
    onClose: () => void,
    asyncAfterOnClose?: () => Promise<void>,
    onClick?: (observacion: string) => void,
    asyncOnClick?: (observacion: string) => Promise<number>;
    mensajeConfirmacion: string,
    classNamemensajeConfirmacion?: string,
    nombreBotonAccion: string,
    nombreBotonCerrarModal?: string,
    nombreBotonAfterOnClose?: string,
    closeAfterAccion: boolean
    hideBotonCerrar: boolean,
    contentModal?: HTMLElement | React.ReactElement
    tituloModal?: string
    tituloModalHTML?: string | React.ReactNode;
    labelObservacion: string
    botonesAccionParteSuperior?: boolean,
    maxLength: number,
    cargando?: boolean

}

type StateModalConfirmacion = {
    realizandoAccion: boolean,
    accionTerminada: boolean,
    errorAsyncAccion: boolean,
    observacion: string
}

export default function ModalRechazo(props: PropsModalConfirmacion) {

    const initialState: StateModalConfirmacion = {
        realizandoAccion: false,
        accionTerminada: false,
        errorAsyncAccion: false,
        observacion: ""
    }

    const [stateModal, setstateModal] = useState<StateModalConfirmacion>(initialState);

    function CerrarModal() {
        setstateModal(initialState);
        props.onClose();
    }

    async function CerrarModalAndAfterClose(callbackClose: () => Promise<void>) {
        setstateModal(initialState);
        await callbackClose();

    }

    const AccionAsync = useCallback(
        async (callbackAccion: any) => {
            const { asyncAfterOnClose } = props;
            setstateModal({ ...stateModal, realizandoAccion: true })
            var statusAccion = await callbackAccion(stateModal.observacion);

            if (props.closeAfterAccion && typeof (asyncAfterOnClose) === "function") {
                await CerrarModalAndAfterClose(asyncAfterOnClose);
            }
            else if (props.closeAfterAccion && typeof (asyncAfterOnClose) === "undefined") {
                CerrarModal();
            }

            else {
                if (statusAccion > -1) {
                    setstateModal({ ...stateModal, realizandoAccion: false, accionTerminada: true })
                }
                else {
                    setstateModal({ ...stateModal, realizandoAccion: false, accionTerminada: true, errorAsyncAccion: true })
                }
            }

        },
        [stateModal],
    )


    function AccionNotAsync(callbackAccion: any) {

        const { closeAfterAccion } = props;
        callbackAccion();

        if (closeAfterAccion) {
            CerrarModal();
        }
    }

    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal handleClickIcon={() => CerrarModal()} />
        )
    }, [props])


    const BotonCancelar = useMemo(() => {
        return (
            <Button color="secondary" disabled={stateModal.realizandoAccion} onClick={() => CerrarModal()}> {props.nombreBotonCerrarModal !== undefined ? props.nombreBotonCerrarModal : "Cerrar Mensaje"} </Button>
        )
    }, [stateModal, props])

    const BotonAccion = useMemo(() => {
        const { asyncOnClick, onClick } = props;



        if (props.asyncAccion && asyncOnClick) {
            return (
                <Button color="primary" disabled={stateModal.observacion === ""} className="mr-2" onClick={async () => await AccionAsync(asyncOnClick)}>{props.nombreBotonAccion}</Button>
            )
        }
        else if (!props.asyncAccion && onClick) {
            return (
                <Button color="primary" disabled={stateModal.observacion === ""} className="mr-2" onClick={() => AccionNotAsync(onClick)}>{props.nombreBotonAccion}</Button>
            )
        }
        else {
            return (<div></div>)
        }


    }, [props, stateModal])

    const BotonCerrarYAccion = useMemo(() => {
        const { asyncAfterOnClose, nombreBotonAfterOnClose } = props

        if (asyncAfterOnClose && nombreBotonAfterOnClose) {
            return (
                <Button color="primary" id="botonAfterOnClose" className="mr-2" onClick={async () => await CerrarModalAndAfterClose(asyncAfterOnClose)}>{nombreBotonAfterOnClose ?? "Cerrar y Continuar"}</Button>
            )
        }
    }, [props, stateModal])

    const ContenidoModal = useMemo(() => {
        const { accionTerminada, realizandoAccion, errorAsyncAccion, observacion } = stateModal;
        const { asyncClose } = props;


        const botonesAcciones = (
            <>
                {!realizandoAccion && !accionTerminada && BotonAccion}
                {!realizandoAccion && accionTerminada && asyncClose && !errorAsyncAccion && BotonCerrarYAccion}
                {!props.hideBotonCerrar && !realizandoAccion && BotonCancelar}

            </>
        )

        var parteinicial = (
            <React.Fragment>
                <Row className="justify-content-center">
                    {
                        !realizandoAccion && !accionTerminada &&
                        <p className={`text-center ${props.classNamemensajeConfirmacion}`}>{props.mensajeConfirmacion}</p>
                    }
                </Row>
                {
                    stateModal.observacion === "" &&
                    <Row>
                        <Col md={12} sm={12}>
                            <small className='small-error'>Indique motivo de negado para habilitar boton</small>
                        </Col>

                    </Row>

                }
            </React.Fragment>

        )

        if (props.botonesAccionParteSuperior !== undefined && props.botonesAccionParteSuperior === true) {
            
            parteinicial = (
                <React.Fragment>
                    <Row className="justify-content-start">
                        {
                            !realizandoAccion && !accionTerminada &&
                            <Col xl={8} lg={8} md={12}>
                                <p className={`text-center ${props.classNamemensajeConfirmacion}`}>{props.mensajeConfirmacion}</p>
                            </Col>
                        }

                        {!realizandoAccion && !accionTerminada && <Col xl={1} lg={1} md={6}>{BotonAccion}</Col>}
                        {!realizandoAccion && accionTerminada && asyncClose && !errorAsyncAccion && <Col xl={1} lg={1} md={6} className="d-flex ">{BotonCerrarYAccion}</Col>}
                        {!props.hideBotonCerrar && !realizandoAccion && <Col xl={1} lg={1} md={6} className="d-flex ">{BotonCancelar}</Col>}

                    </Row>
                    {
                        stateModal.observacion === "" &&
                        <Row className="mb-2"> 
                            <Col md={12} sm={12} className="text-center">
                                <small className='small-error'>Indique motivo de negado para habilitar boton</small>
                            </Col>

                        </Row>

                    }

                </React.Fragment>

            );
        }

        if (props.cargando !== undefined && props.cargando === true) {
            return (
                <Cargando />
            )
        }

        return (
            <Container>

                {
                    props.contentModal
                }

                <Row className="justify-content-center">
                    <Col>
                        <FormGroup>
                            <Label for="estadoSolicitud">
                                {props.labelObservacion + ` (hasta ${props.maxLength} caracteres)*`}
                            </Label>
                            <Input
                                id="observacionRechazo"
                                name="observacionRechazo"
                                type="textarea"
                                rows="5"
                                value={observacion}
                                maxLength={props.maxLength}
                                onChange={(e) => setstateModal({ ...stateModal, observacion: e.target.value })}
                            />
                        </FormGroup>
                    </Col>

                </Row>

                {
                    parteinicial
                }

                <Row className="justify-content-center">

                    {
                        (props.botonesAccionParteSuperior === undefined || (props.botonesAccionParteSuperior !== undefined && props.botonesAccionParteSuperior === false))
                        && botonesAcciones
                    }


                </Row>
                <Row>
                    <Col>
                        {
                            realizandoAccion && !accionTerminada &&
                            <Row className="justify-content-center">
                                <Cargando />
                            </Row>
                        }
                    </Col>

                </Row>
                <Row className="justify-content-center">
                    <Col>
                        {
                            !realizandoAccion && accionTerminada && !errorAsyncAccion &&
                            <p className='error-small'>Se ha completado la acción</p>
                        }
                        {
                            !realizandoAccion && accionTerminada && errorAsyncAccion &&
                            <p className='error-small'>Ha ocurrido un inconveniente al tratar de realizar la acción</p>
                        }
                    </Col>
                </Row>
            </Container>
        )
    }, [props, stateModal])

    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={false}
            onClosed={() => CerrarModal()}
        // contentClassName="custom-modal-style"
        >
            <ModalHeader close={BotonCerrar}>
                <div className='tituloModalDocumentos'>
                    {props.tituloModalHTML ? (
                        typeof props.tituloModalHTML === "string" ? 
                        <div dangerouslySetInnerHTML={{ __html: props.tituloModalHTML }} /> : 
                        props.tituloModalHTML
                    ) : props.tituloModal ? (
                        props.tituloModal
                    ) : (
                        "Mensaje de confirmación"
                    )}
                </div>
                
            </ModalHeader>
            <ModalBody>
                <>

                    {ContenidoModal}
                </>

            </ModalBody>

        </Modal>
    )
}
